import React from 'react';
import PopoverHeader, { PopoverHeaderProps } from './Header';
import styles from './popover.module.scss';

type Props = {
  children?: any;
} & PopoverHeaderProps;

/**
 * Body in a popover.
 */
export default function PopoverBody(props: Props) {
  return (
    <div className={styles.body}>
      <PopoverHeader {...props} />
      <div className={styles.content}>
        {props.children}
      </div>
    </div>
  )
}